import React from 'react';
import Image from 'next/image';

const features = [
  {
    title: 'Order Management',
    description: 'Streamline your operations with real-time order tracking, status updates, and efficient workflows.',
    placeholder: 'https://rgvfkcfnfbtqyjlrvynz.supabase.co/storage/v1/object/public/vendor-assets/vendor-assets/features/order.png',

  },
  {
    title: 'Payments & Invoicing',
    description: 'Track multiple payments and generate professional, customizable invoices for your customers.',
    placeholder: 'https://rgvfkcfnfbtqyjlrvynz.supabase.co/storage/v1/object/public/vendor-assets/vendor-assets/features/payments.png',

  },
  {
    title: 'Inventory Management',
    description: 'Track anything, set low stock alerts, and manage suppliers all in one place.',
    placeholder: 'https://rgvfkcfnfbtqyjlrvynz.supabase.co/storage/v1/object/public/vendor-assets/vendor-assets/features/inventory.png',

  },
  {
    title: 'Customer Insights',
    description: 'Understand your customers better with detailed analytics and order history.',
    placeholder: 'https://rgvfkcfnfbtqyjlrvynz.supabase.co/storage/v1/object/public/vendor-assets/vendor-assets/features/analytics.png',

  },
  {
    title: 'Digital Menu',
    description: 'Beautiful, customizable digital menus that update in real-time across all platforms.',
    placeholder: 'https://rgvfkcfnfbtqyjlrvynz.supabase.co/storage/v1/object/public/vendor-assets/vendor-assets/features/products.png',

  },
  {
    title: 'Shop',
    description: 'Delight your customers with a seamless online ordering experience, complete with menu browsing and easy checkout.',
    placeholder: 'https://rgvfkcfnfbtqyjlrvynz.supabase.co/storage/v1/object/public/vendor-assets/vendor-assets/features/ecom.png',

  },
];

export const FeaturesSection = () => {
  return (
    <div className="w-full mt-16 mb-16 px-2 sm:px-4 sm:mt-20 sm:mb-20 md:mt-24 md:mb-24 lg:mt-32 lg:mb-32">
      <div className="text-center mb-8 sm:mb-12 md:mb-16">
        <h2 className="text-2xl font-normal mb-4 sm:text-3xl sm:mb-5 md:text-4xl md:mb-6 lg:text-5xl">
          Everything you need to grow your business
        </h2>
        <p className="text-muted-foreground max-w-xs mx-auto text-base leading-relaxed sm:max-w-lg sm:text-lg md:max-w-2xl">
          Powerful features designed to streamline your operations, delight your customers, and accelerate your growth.
        </p>
      </div>
        
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        {features.map((feature, index) => (
          <div key={index} className="text-left">
            <div className="mb-4 overflow-hidden sm:mb-5 md:mb-3 bg-gray-100 rounded-xl">
              <Image
                src={feature.placeholder}
                alt={`${feature.title} screenshot placeholder`}
                width={200}
                height={100}
                className="w-full h-48 rounded-xl object-contain sm:h-56 md:h-64"
              />
            </div>
            <h3 className="text-md font-normal mb-3 text-gray-900 sm:text-xl sm:mb-4 md:text-md">
              {feature.title}
            </h3>
            <p className="text-gray-400 font-normal text-sm leading-relaxed sm:text-sm md:text-sm">
              {feature.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};
